import { memo } from 'react'
import { IconButton, SwipeableDrawer, SxProps } from '@mui/material'
import { CrossThinIcon } from '@/assets'

import { Box } from '@/components/Layout'
import { Text } from '@/components/Data'
import { ActionButtons } from '@/components/Inputs'
import { bottomDrawerStyles as styles } from './BottomDrawer.style'
import { BottomDrawerProps } from './BottomDrawer.types'

function BottomDrawer({
  heading: title,
  children,
  actionButtonProps,
  closeButton,
  contentWrapperProps = {},
  mainContentWrapperProps = {},
  hideHeading = false,
  slotProps = {},
  ...props
}: BottomDrawerProps) {
  const { sx: contentWrapperSx, ...otherContentWrapperProps } = contentWrapperProps
  const { sx: mainContentWrapperSx, ...otherMainContentWrapperProps } = mainContentWrapperProps

  const anchor = props.anchor || 'bottom'

  return (
    <SwipeableDrawer
      anchor={anchor}
      slotProps={{ paper: { sx: styles.wrapper }, ...slotProps }}
      disableSwipeToOpen={anchor === 'bottom'}
      {...props}>
      <Box
        sx={
          [
            styles.contentWrapper,
            actionButtonProps && styles.contentWrapperNoBottomSpacing,
            contentWrapperSx,
          ] as SxProps
        }
        {...otherContentWrapperProps}>
        {!hideHeading && (
          <Box sx={styles.heading}>
            {title && <Text sx={styles.headingText}>{title}</Text>}

            {closeButton || (
              <IconButton sx={styles.closeIcon} onClick={props.onClose}>
                <CrossThinIcon className="icon" />
              </IconButton>
            )}
          </Box>
        )}
        <Box
          sx={[styles.mainContent, mainContentWrapperSx] as SxProps}
          {...otherMainContentWrapperProps}>
          {children}
        </Box>
      </Box>

      {actionButtonProps && <ActionButtons {...actionButtonProps} />}
    </SwipeableDrawer>
  )
}

export default memo(BottomDrawer)
